export default __webpack_public_path__ + "static/media/attendance-money.7679f3a4.svg";